import * as React from "react";
const ClothesCorporateFemaleGreyGreen = () => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		xmlnsXlink="http://www.w3.org/1999/xlink"
		viewBox="0 0 1080 1920"
	>
		<defs>
			<style>
				{
					".cls-corp-f-grey-green-1{fill:none;}.cls-corp-f-grey-green-2{fill:#282b2e;}.cls-corp-f-grey-green-3{fill:#162f4b;}.cls-corp-f-grey-green-4{clip-path:url(#clip-path-corp-f-grey-green);}.cls-corp-f-grey-green-5{fill:#3c8a7d;}.cls-corp-f-grey-green-6{fill:#5d5d5d;}"
				}
			</style>
			<clipPath id="clip-path-corp-f-grey-green">
				<path
					className="cls-corp-f-grey-green-1"
					d="M690.14,587.87s3,40,4,42.77C702.91,631.44,760,598,760,598c0-7.92-8.36-113.7-13-128-4.51-13.9-9.07-19.37-20-31-5.63-6-80.64-41.25-90.26-45.22a15.35,15.35,0,0,0-1.92-7.92c-3.85-4-21.5-13.86-21.5-13.86,0,8.47,0,10.35,9.13,18.82-.38,14.23-6.86,24.75-20.33,42.57s-38.47,15.84-38.47,15.84-25,2-38.47-15.84S505,405.05,504.57,390.82c6.4-5.65,10.05-11.29,8.23-16.94,0,0-16.47,8-20.31,12a15.28,15.28,0,0,0-1.93,7.92C481,397.75,400,435,394,442c-7.28,8.49-14.49,21.1-19,35-4.64,14.3-8,113.08-8,121,0,0,54.4,32.44,63.13,31.64,1-2.79,3-42.77,3-42.77S455.51,705.46,447,731c-10,30-40,146-40,146s82,25,157,25,155-25,155-25-36.23-121.26-42-147S690.14,587.87,690.14,587.87Z"
				/>
			</clipPath>
		</defs>
		<title>{"corporate f gris et vert"}</title>
		<g id="Calque_1" data-name="Calque 1">
			<rect className="cls-corp-f-grey-green-1" width={1080} height={1920} />
		</g>
		<g id="corporate_f" data-name="corporate f">
			<path
				className="cls-corp-f-grey-green-2"
				d="M531,1665l13,71v46c0,8.42,12,51,10,54s-15.53,7-45,7-59-5-61-10,15.79-60.69,20-67,4.78-58.58,4.78-58.58L474,1674l30.35-4.47Z"
			/>
			<path
				className="cls-corp-f-grey-green-2"
				d="M592,1665l-13,71v46c0,8.42-12,51-10,54s15.53,7,45,7,59-5,61-10-15.79-60.69-20-67-4.78-58.58-4.78-58.58L649,1674l-30.35-4.47Z"
			/>
			<path
				className="cls-corp-f-grey-green-3"
				d="M712.65,865.56,563,891.82,413.35,865.56S404,897.74,404,923s26,393,26,418c0,23.53.88,171.69,17,229,18,64,20,109,20,109l69-10s5-94.75,4-168c-.68-48.55.84-67.45,0-75-2.1-18.94,5-54,7-87,3.19-52.57,7-287,7-287s5.79-3,7.9-3h2.2c2.11,0,7.9,3,7.9,3s3.81,234.43,7,287c2,33,9.1,68.06,7,87-.84,7.55.68,26.45,0,75-1,73.25,4,168,4,168l69,10s2-45,20-109c16.12-57.31,17-205.47,17-229,0-25,26-392.74,26-418S712.65,865.56,712.65,865.56Z"
			/>
			<g className="cls-corp-f-grey-green-4">
				<path
					className="cls-corp-f-grey-green-6"
					d="M772,617s-2-24.78-1-22c4-19-14-35-14-35,0-7.92-2.36-76.7-7-91-4.51-13.9-11.39-27.81-20.93-33.63-7-4.28-82.71-37.62-92.33-41.59a15.35,15.35,0,0,0-1.92-7.92c-3.85-4-21.16-13.07-21.16-13.07,0,7.13,8.08,12.7,9.62,15-.38,14.24-7.69,27.73-21.16,45.55s-38.47,15.84-38.47,15.84-25,2-38.47-15.84S504.41,402.08,504,387.84c1.54-2.35,9.61-7.92,9.61-15,0,0-17.31,9.11-21.15,13.07a15.28,15.28,0,0,0-1.93,7.92c-9.61,4-85.3,37.31-92.32,41.59-9.55,5.82-24.34,19.76-28.85,33.67C364.74,483.34,354,542.3,354,550.23c0,0-7.73,41.57,1,40.77,1-2.78-5,24-5,24s50.77,207.26,45,233,24.4,108.18,24.4,108.18,69.24,35.65,144.25,35.65S728,902,728,902s-7.23-38.26-13-64S772,617,772,617Z"
				/>
				<path
					className="cls-corp-f-grey-green-5"
					d="M434,623.81V609s-57.38-46.12-67-58-11.71,37.17-7,45,70,39,70,39Z"
				/>
				<path
					className="cls-corp-f-grey-green-5"
					d="M688,625.81,689,609s58.38-42.12,68-54,14,36,14,36c-17.81,13.24-46.3,27-77,42Z"
				/>
				<path
					className="cls-corp-f-grey-green-5"
					d="M562.28,449.29s-19.78,9.84-23.63,29.65c-21.16-13.87-44.24-47.53-46.16-61.39S490.56,374,490.56,374l30.78-7.92Z"
				/>
				<path
					className="cls-corp-f-grey-green-5"
					d="M565.58,449.29s19.78,9.84,23.63,29.65c21.16-13.87,44.24-47.53,46.16-61.39S637.29,374,637.29,374l-30.77-7.92Z"
				/>
				<path
					className="cls-corp-f-grey-green-5"
					d="M711,852c-34.44,23.57-147,23-147,23s-115.56-2.43-150-26c-12.22,8.92-10,31-10,31l150,27.71L564,902l9.27,5.71L725,882S718.91,858.92,711,852Z"
				/>
			</g>
		</g>
	</svg>
);
export default ClothesCorporateFemaleGreyGreen;
